import { Link } from "react-router-dom";
import { ArrowLeft, Heart } from "lucide-react";

const CONTENT = {
  terms: {
    title: "Terms of Service",
    body: [
      ["What MyySpace is", "MyySpace offers emotional support, listening and guidance from an experienced, compassionate listener. It is NOT medical, psychological, psychiatric, or crisis treatment, and is not a substitute for professional clinical care."],
      ["Booking a session", "Sessions are requested through our form or WhatsApp. A request is not a confirmed session. We confirm the time and share payment details privately over WhatsApp before any session takes place."],
      ["Payments", "There is no online checkout. Payment is arranged privately over WhatsApp (for example via UPI) after we confirm your session."],
      ["Your responsibilities", "Please share accurate contact details. If you are under 18, you must have a parent or guardian's consent before booking. Sessions are for supportive listening and are not appropriate for emergencies."],
      ["Not for emergencies", "If you are in danger or thinking of self-harm, contact Tele-MANAS (14416), iCall, or AASRA, or your local emergency services immediately."],
      ["Changes", "We may update these terms from time to time. Continued use of MyySpace means you accept the current terms."],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    body: [
      ["What we collect", "When you submit a request we collect your name, email, contact number, preferred day/time, chosen session mode, and anything you optionally choose to share about what you'd like to talk about."],
      ["How we use it", "We use your details only to contact you, confirm a session, and provide the listening service you requested. A copy of your request is sent to our private inbox."],
      ["Confidentiality", "What you share in sessions stays private. The only exception is where there is a serious risk of harm to you or someone else, in which case we may encourage professional or emergency support."],
      ["Sharing", "We do not sell or share your personal information with third parties for marketing. Communication happens over WhatsApp, which has its own privacy terms."],
      ["Your choices", "You can ask us to delete your request details at any time by messaging us on WhatsApp."],
    ],
  },
  refund: {
    title: "Refund & Cancellation",
    body: [
      ["Before payment", "Since no payment is taken online, you can cancel a request at any time before you've paid — simply let us know on WhatsApp."],
      ["Rescheduling", "Life happens. If you need to reschedule, message us on WhatsApp and we'll find a new time on mutual availability."],
      ["3-session pack", "The 3-session pack is intended to be used within one month of the first session, scheduled on mutual availability."],
      ["Refunds", "If you've paid for a session that hasn't happened yet and wish to cancel, reach out on WhatsApp and we'll work out a fair resolution."],
    ],
  },
};

const Legal = ({ page }) => {
  const c = CONTENT[page];
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-[#FDFBF7]/90 backdrop-blur-md">
        <div className="max-w-3xl mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="legal-home-link">
            <span className="flex items-center justify-center w-9 h-9 rounded-full bg-primary text-primary-foreground"><Heart className="w-5 h-5" /></span>
            <span className="font-serif text-xl font-semibold">MyySpace</span>
          </Link>
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1">
            <ArrowLeft className="w-4 h-4" /> Back home
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-16" data-testid={`legal-${page}`}>
        <h1 className="font-serif text-4xl font-semibold tracking-tight mb-10">{c.title}</h1>
        <div className="space-y-8">
          {c.body.map(([h, p], i) => (
            <section key={i}>
              <h2 className="font-serif text-xl mb-2">{h}</h2>
              <p className="text-muted-foreground leading-relaxed">{p}</p>
            </section>
          ))}
        </div>
        <p className="text-xs text-muted-foreground/70 mt-12">Last updated {new Date().toLocaleDateString()}</p>
      </main>
    </div>
  );
};

export default Legal;
